import { Button, Form, Input, Select } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Detergent, TankMethodType } from '@/types'
import { CreateTankRequest } from '@/types/apis/tanks/createTankRequest'

import { SelectWrapper } from '../../Customer/styles'
import { SpaceCustom } from '../../style'

type Props = {
  loading: boolean
  detergents: Detergent[] | undefined
  onSubmit: (formValues: CreateTankRequest) => void
}

type Options = {
  value: TankMethodType
  label: string
}

const CreateTankComponentForm = ({ loading, onSubmit, detergents }: Props) => {
  const { t } = useTranslation()
  const [netWeightMl, setNetWeightMl] = useState<number>()

  const tankOptions: Options[] = [
    { value: TankMethodType.MANUAL, label: t('components.pages.tanks.create.form.manual') },
    { value: TankMethodType.AUTOMATIC, label: t('components.pages.tanks.create.form.automatic') },
  ]

  const handleSelectDetergent = (value: number) => {
    const detergent = detergents?.find((d) => d.id === value)
    if (detergent) {
      setNetWeightMl(detergent.netWeightMl || 0)
    }
  }

  return (
    <Form layout="vertical" onFinish={onSubmit}>
      <Form.Item
        label={t('components.pages.tanks.create.form.tankNo')}
        name="tankNo"
        rules={[{ required: true, message: t('components.pages.tanks.create.form.requireTankNo') }]}
      >
        <Input type="number" min={0} />
      </Form.Item>

      <SelectWrapper>
        <Form.Item
          label={t('components.pages.tanks.update.form.detergentName')}
          name="detergentIds"
          rules={[{ required: true, message: t('components.pages.tanks.create.form.requireDetergentName') }]}
        >
          <Select onChange={handleSelectDetergent}>
            {detergents?.map((detergent) => (
              <Select.Option key={detergent.id} value={detergent.id}>
                {detergent.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </SelectWrapper>

      <SelectWrapper>
        <Form.Item
          label={t('components.pages.tanks.update.form.method')}
          name="method"
          rules={[{ required: true, message: t('components.pages.tanks.create.form.requireMethod') }]}
        >
          <Select>
            {tankOptions.map((option, index) => (
              <Select.Option key={index} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </SelectWrapper>

      <Form.Item label={t('components.pages.tanks.create.form.netWeightMl')}>
        <Input type="number" min={0} suffix="ml" value={netWeightMl} disabled />
      </Form.Item>

      <Form.Item
        label={t('components.pages.tanks.create.form.thresholdQuantity')}
        name="thresholdQuantity"
        rules={[{ required: true, message: t('components.pages.tanks.create.form.requireThresholdQuantity') }]}
      >
        <Input type="number" min={0} suffix="ml" />
      </Form.Item>

      <Form.Item
        label={t('components.pages.tanks.create.form.remainingQuantity')}
        name="remainingQuantity"
        rules={[{ required: true, message: t('components.pages.tanks.create.form.requireRemainingQuantity') }]}
      >
        <Input type="number" min={0} suffix="ml" />
      </Form.Item>

      <SpaceCustom>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            {t('components.pages.machines.create.form.submit')}
          </Button>
        </Form.Item>
      </SpaceCustom>
    </Form>
  )
}

CreateTankComponentForm.displayName = 'CreateTankComponentForm'
export default CreateTankComponentForm
